<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" :placeholder="$t('menu.FrameNumber') + '/' + $t('menu.EngineNumber')"
          v-model="formInline.poShipmentId"></el-input>
       
      </el-form-item>
      
     
     
    
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
      
      </el-form-item>
    </el-form>
   
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
      <el-table-column prop="createdTime"  label="发货日期" > </el-table-column>
      <el-table-column prop="poShipmentId"  label="发货单号" > </el-table-column>
      <el-table-column prop="partNumber"  label="关联配件" > </el-table-column>
    
      <el-table-column prop="shippedQuantity"  label="发货数量"> </el-table-column>
      <!-- <el-table-column prop="partName"  label="发货整车数量" > </el-table-column> -->
   
      
     
     
     
    </el-table>
 <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, prev, pager, next"
        :total="totale">
      </el-pagination>
    </div>
    

 
  </div>
</template>
  
  <script>
import { ShipmentDetailsrlist,retailerlist } from "../../api/api";

export default {
  data () {
    return {
      userId: null,
   
      mation: [], //列表
      cartypelist: [],
      formInline: {
        poShipmentId: "",
       
      },
      currentPage3:1,
      iszh:sessionStorage.getItem('i18n'),
   
    };
  },
  created () {
    // this.listMcSeriesModel()
    this.getList()
    this.getQuerytype()
  },
 
  methods: {
      handleSizeChange (val) {
      // this.pageSize = val
      this.getList();
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.getList();
    },
   
    //查询车辆列表
    getList () {
 
      let params = new URLSearchParams();
      let poShipmentId=this.formInline.poShipmentId
    let poId=""
      let curPage=this.currentPage3
      let pageSize=10
      ShipmentDetailsrlist(params,poShipmentId,curPage,pageSize,poId).then(res => {
        if (res.data.code == 200) {
          this.mation = res.data.rows
          this.totale = res.data.total
        }
      })
    },
   
   
   
 
    //搜索
    onSubmit () {
      this.getList()
    },
  
     //零售商
    getQuerytype () {
 
      const params = new URLSearchParams()
      retailerlist( params, 1,1000).then(r => {
        console.log(r);
        this.cartypelist = r.data.rows;
    
      })
    },
    
  
  },
};
</script>

<style lang="less" scoped>
.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

</style>